import React from "react";

export function PrimaryButton({
  children,
  type = "button",
  className = "",
  disabled,
  ...props
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={`inline-flex h-12 min-w-[10rem] items-center justify-center rounded-none border border-accent bg-accent px-8 font-body text-xs font-medium uppercase tracking-[2px] text-white transition-colors duration-300 hover:bg-primary disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
